<h1 mat-dialog-title>Sonderrecht {{ bbr ? "bearbeiten" : "anlegen" }}</h1>
<div mat-dialog-content>
    <kiene-autocomplete
        [placeholder]="'Benutzer'"
        apiUrl="benutzer/"
        [showClear]="false"
        [showDeleteButton]="false"
        [required]="true"
        [displayFields]="['nachname', 'vorname', 'email']"
        separator=", "
        [kieneObject]="benutzer"
        [focus]="false"
        (elementSelected)="selectedBenutzer($event)"
    >
    </kiene-autocomplete>
    <kiene-autocomplete
        [placeholder]="'Benutzerrecht'"
        apiUrl="benutzerrecht/"
        [showClear]="false"
        [showDeleteButton]="false"
        [required]="true"
        [displayFields]="['benutzerrecht_id', 'bezeichnung']"
        separator=" | "
        [kieneObject]="benutzerrecht"
        [focus]="false"
        (elementSelected)="selectedBenutzerrecht($event)"
    >
    </kiene-autocomplete>
</div>
<div mat-dialog-actions>
    <span class="spacer"></span>
    <button mat-button (click)="cancel()">Abbrechen</button>
    <button mat-flat-button color="accent" (click)="save()" [disabled]="!benutzer && !benutzerrecht">Speichern</button>
</div>
